import { render } from "./CartCellTag.vue?vue&type=template&id=82cf95ae&scoped=true"
import script from "./CartCellTag.vue?vue&type=script&lang=js"
export * from "./CartCellTag.vue?vue&type=script&lang=js"

import "./CartCellTag.vue?vue&type=style&index=0&id=82cf95ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cf95ae"]])

export default __exports__